import type { RouteLocationNormalizedLoaded } from 'vue-router'

import starApi from '@/api/starApi'
import { getStarAppVersion } from '@/utils/useStarTheme'

/** 0 元升级活动位 position */
export const STAR_UNLOCK_ACTIVITY_POSITION = 'jfztpc.xtfwsj'

export interface StarUnlockActivity {
  id?: string | number
  /** 弹框内缩略图，对应接口 image */
  image: string
  /** 宣传页主图，对应接口 detailImage */
  detailImage: string
  /** 扫码升级链接 */
  qrUrl: string
  link: string
  guideType: string
  guideContent: string
}

export function parseStarUnlockActivity(raw: Record<string, any>): StarUnlockActivity | null {
  const image = raw.image || ''
  const detailImage = raw.detailImage || raw.detailImg || ''
  const qrUrl = raw.link || raw.guideContent || ''

  if (!image && !detailImage && !qrUrl) return null

  return {
    id: raw.id ?? raw.activityId,
    image,
    detailImage,
    qrUrl,
    link: raw.link || '',
    guideType: raw.guideType || '',
    guideContent: raw.guideContent || '',
  }
}

/** 拉取星投 0 元升级活动配置 */
export async function fetchStarUnlockActivity(
  route: RouteLocationNormalizedLoaded
): Promise<StarUnlockActivity | null> {
  const token = route.query.token as string
  const appVersion = getStarAppVersion(route.query)

  try {
    const res: any = await starApi.getUnlockActivityPages({
      headers: {
        token,
        clientType: 'pc',
        appVersion,
      },
    })
    const list: Record<string, any>[] = res?.data?.list || []
    if (!list.length) return null

    const isLogin = token ? 1 : 0
    const matched = list.find((item) => {
      if (item.hiddenStatus && item.hiddenStatus !== 'SHOWN') return false
      if (item.needLogin != null && item.needLogin !== isLogin) return false
      return true
    }) || list[0]

    return parseStarUnlockActivity(matched)
  } catch (e) {
    console.error('[fetchStarUnlockActivity] 获取 0 元升级活动失败', e)
    return null
  }
}
